// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_50f3376","eachWay":"_79710da"};